import * as React from 'react'
import * as classNames from 'classnames'
import { getBannerStyles, NoResultsClass } from '@sphinx/components-styles'
import NoResultsImageSrc from '../../assets/405.svg'

const NoResults = getBannerStyles({
  width: 420,
  height: 117,
  bannerImgSrc: NoResultsImageSrc,
})

interface NoResultsBannerProps extends React.HTMLAttributes<HTMLDivElement> {
  message: string
}

export const NoResultsBanner: React.FC<NoResultsBannerProps> = ({
  children,
  className,
  message,
  ...props
}) => (
  <div className={classNames(NoResults, className)} {...props}>
    <p>{message}</p>
    {React.Children.toArray(children)}
  </div>
)

export const StoriesNoResultsActions: React.FC<
  React.HTMLAttributes<HTMLDivElement>
> = ({ children, className, ...props }) => (
  <div className={classNames(NoResultsClass.actions, className)} {...props}>
    {children}
  </div>
)
